import Duck from 'extensible-duck';
import Immutable from 'immutable';

import requestsManagerAxios from '../../lib/requestsManagerAxios';

export default new Duck({
  namespace: 'all',
  store: 'railsContext',
  types: [
    'UPDATE_IS_PREVIEWING_WEBSITE',
    'UPDATE_IS_PREVIEWING_WEBSITE_PENDING',
    'UPDATE_IS_PREVIEWING_WEBSITE_REJECTED',
    'UPDATE_IS_PREVIEWING_WEBSITE_FULFILLED',
  ],
  initialState: Immutable.fromJS({
    isPreviewingWebsite: false,
  }),
  reducer: ($$state, { type, payload, _meta }, { types }) => {
    switch (type) {
      case types.UPDATE_IS_PREVIEWING_WEBSITE_REJECTED:
        location.reload();
        return $$state;
      case types.UPDATE_IS_PREVIEWING_WEBSITE_FULFILLED:
        return $$state.merge({
          isPreviewingWebsite: payload.data.is_previewing_website,
        });
      default:
        return $$state;
    }
  },
  selectors: {
    isPreviewingWebsite: $$state => $$state.get('isPreviewingWebsite'),
  },
  creators: ({ types }) => ({
    updateIsPreviewing: value => ({
      type: types.UPDATE_IS_PREVIEWING_WEBSITE,
      payload: requestsManagerAxios.post(
        '/admin/user/toggle_previewing_website',
        { is_previewing_website: value === 'preview' }
      ),
    }),
  }),
});
